export const isFedex = (code?: string) => code === 'fxfe'
